import React from 'react';
import { createRoot } from 'react-dom/client';
import { createInertiaApp } from '@inertiajs/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import App from '../App';

const queryClient = new QueryClient();

const rootElement = document.getElementById('root');

if (rootElement) {
  // Inertia page 데이터 감지 (<div data-page="..."> 또는 <script data-page="...">)
  let initialPage: any = null;
  const scriptTag = document.querySelector(`script[data-page="${rootElement.id}"][type="application/json"]`);
  if (scriptTag?.textContent) {
    try {
      initialPage = JSON.parse(scriptTag.textContent);
    } catch (e) {
      console.error('Failed to parse Inertia page JSON from script tag', e);
    }
  } else if (rootElement.dataset.page) {
    try {
      initialPage = JSON.parse(rootElement.dataset.page);
    } catch (e) {
      console.error('Failed to parse Inertia page JSON from data-page attribute', e);
    }
  }

  if (initialPage) {
    // Inertia 앱 마운트
    createInertiaApp({
      id: rootElement.id,
      page: initialPage,
      resolve: (name) => {
        const pages = import.meta.glob('../pages/**/*.tsx', { eager: true });
        const component =
          pages[`../pages/${name}.tsx`] ||
          pages[`../pages/${name}/index.tsx`] ||
          pages[`../pages/notes/${name}.tsx`];
        if (!component) {
          throw new Error(`Inertia Page component not found: ${name}`);
        }
        return component;
      },
      setup({ el, App: InertiaApp, props }) {
        createRoot(el).render(
          <React.StrictMode>
            <QueryClientProvider client={queryClient}>
              <InertiaApp {...props} />
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </React.StrictMode>
        );
      },
    });
  } else if (document.getElementById('root-data')) {
    // 기존 Presenter 기반의 React 페이지인 경우에만 React Router 앱 마운트
    createRoot(rootElement).render(
      <React.StrictMode>
        <QueryClientProvider client={queryClient}>
          <App />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </React.StrictMode>
    );
  }
}
